import { rei } from "@/services/api"

class ProtocolosService {
  static index (params) {
    return rei.get(`/protocolos`, { params }).then(res => res.data)
  }

  static anosUsados () {
    return rei.get('/protocolo-anos-usados').then(res => res.data)
  }

  static show (id) {
    return rei.get(`/protocolos/${ id }`).then(res => res.data)
  }

  static delete (id) {
    return rei.delete(`/protocolos/${ id }`).then(res => res.data)
  }

  static cumprir (protocolo) {
    const payload = {
      status: 'CUMPRIDO',
      data_cumprimento: protocolo.data_cumprimento
    }

    return rei.put(`/protocolos/${ protocolo.id }`, payload).then(res => res.data)
  }

  static cancelar (protocolo) {
    const payload = {
      status: 'CANCELADO',
      data_cancelamento: protocolo.data_cancelamento,
      motivo_cancelamento: protocolo.motivo_cancelamento
    }

    return rei.put(`/protocolos/${ protocolo.id }`, payload).then(res => res.data)
  }

  static reverter (protocolo) {
    const payload = {
      status: 'EM_ANDAMENTO'
    }

    return rei.put(`/protocolos/${ protocolo.id }`, payload).then(res => res.data)
  }

  static store (protocolo) {
    const payload = ProtocolosService.tratarPayload(protocolo)

    if (payload.status != 'CUMPRIDO') {
      delete payload.data_cumprimento
    }

    return rei.post(`/protocolos`, payload).then(res => res.data)
  }

  static update (id, protocolo) {
    const payload = ProtocolosService.tratarPayload(protocolo)

    return rei.put(`/protocolos/${id}`, payload).then(res => res.data)
  }

  static tratarPayload (protocolo) {
    if (protocolo.matricula != null) {
      protocolo.matricula = !!protocolo.matricula && protocolo.matricula.replace(/ /g, '') || ''
      const informacoes = [
        {
          chave: 'matricula',
          valor: protocolo.matricula
        }
      ]

      if (!protocolo.informacoes) {
        protocolo.informacoes = informacoes
      } else {
        const matricula = protocolo.informacoes.find(info => info.chave == 'matricula')
        if (matricula) {
          matricula.valor = protocolo.matricula
        } else if (protocolo.matricula) {
          protocolo.informacoes.push({ chave: 'matricula', valor: protocolo.matricula })
        }
      }

      delete protocolo.matricula
    }

    // tratamos as partes
    protocolo.partes = protocolo.partes.map(parte => {
      parte.cpf = parte.cpf && parte.cpf.replace(/[.-]/g, '') || null
      return parte
    })

    return protocolo
  }
}

export default ProtocolosService
